import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import HobbiesPage from './hobbies'

const hobbyRoutes: Route[] = [
  {
    path: Paths.SETTING_HOBBIES,
    element: <HobbiesPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default hobbyRoutes
